module.exports = __webpack_public_path__ + "static/media/logout.1d8c3417.svg";